import { createContext } from "react";

export const TestsContext = createContext();
